var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleChatTyping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    overflow: "visible",
    display: "inline-block",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 16.482a1 1 0 001 1h2v4l4-4h15a1 1 0 001-1v-13a1 1 0 00-1-1h-21a1 1 0 00-1 1v13z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 9.982,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.982,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 9.982,
    r: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))));
}
export default SvgBubbleChatTyping;